// Spacing multipliers, not pixels: the same tokens drive both the styles and the overflow budget, so
// the two can never drift. Resolved to numbers at the call site via `theme.spacing()`.

// Gap between chips — in the inline strip, in the hidden measurement layer, and as the gap the start
// adornment keeps from the text field. Owning that last one (instead of inheriting MUI's adornment
// margin) is what lets the overflow budget account for it from the same token.
export const CHIP_GAP_SPACING = 0.5;

// The input's OUTER minimum width — applied as its `minWidth` in StyledComponents, where the input is
// also forced to `border-box` so this token means the same thing there as it does in the overflow
// budget, which subtracts it from an outer width. NOT the width of the typing area: the input's own
// horizontal padding comes out of it. Without a floor at all the chip strip won the flex negotiation
// and collapsed the field to a few characters.
export const INPUT_MIN_SPACING = 15;

// Visible-chip count for the single frame before the first measurement lands. The measurement runs
// in a layout effect, which is flushed before paint, so this is rarely painted at all. One, not the
// three that mirrored the fixed threshold preceding DA-19687 — that rationale died with the fixed
// threshold, and if the frame ever IS painted, under-showing corrects itself on the next commit while
// over-showing paints a strip wider than its lane.
//
// This is the NOT-YET-MEASURED value only. A measured "no room" resolves to zero visible chips
// through fitVisibleCount, never through here.
export const FALLBACK_VISIBLE_CHIPS = 1;
